module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "set-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "set-logo"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/logo_gray.png"),
      "height": "30",
      "width": "30"
    }
  }), _vm._v(" "), _c('span', [_vm._v("\n                   六六脑\n                   "), _c('sup', [_vm._v("®")]), _vm._v("\n                     脑康复云\n               ")])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("../../assets/img/img_502.png"),
      "height": "220",
      "width": "433"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("啊哦，出错啦，找不到您访问的页面")]), _vm._v(" "), _c('p', [_vm._v("您可以查看:")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "400px",
      "display": "flex",
      "justify-content": "space-around",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "button-66nao 66nao",
    attrs: {
      "onclick": "window.location.reload(true)"
    }
  }, [_vm._v("刷新")]), _vm._v(" "), _c('div', {
    staticClass: "button-66nao 66nao",
    attrs: {
      "onclick": "location.href = 'http://www.66nao.com/'"
    }
  }, [_vm._v("六六脑官网")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28d5a22c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/502.vue
// module id = 967
// module chunks = 2